import fleur from "../img/cele-mai-vindute/fleur.webp";
// import petalAffair from "../img/buchete/3petal-affair.webp";
// import freshBloom from "../img/buchete/4fresh-bloom.webp";
import pinkHarmony from "../img/cele-mai-vindute/Pink-Harmony.webp";
import petalEmbrace from "../img/buchete/6petal-embrace.webp";
import floralElegance from "../img/buchete/7floral-elegance.webp";
// import noble from "../img/buchete/9noble.webp";
import sereneBloom from "../img/buchete/10serene-bloom.webp";
import purity from "../img/buchete/11purity.webp";
// import cheer from "../img/buchete/12cheer.webp";
// import blushRose from "../img/buchete/13blush.webp";
// import illume from "../img/buchete/14illume.webp";
import featherlight from "../img/buchete/15featherlight.webp";
import whiteSerenity from "../img/buchete/17white-serenity.webp";
import hydrangeaCascade from "../img/buchete/18cascade.webp";
// import belle from "../img/buchete/19belle.webp";
// import gleam from "../img/buchete/20gleam.webp";
import petalJewel from "../img/buchete/21petal-jewel.webp";
import whispery from "../img/buchete/23whispery.webp";
import roselight from "../img/buchete/24roselight.webp";
// import finesse from "../img/buchete/25finesse.webp";
import snowdrop from "../img/buchete/26snowdrop.webp";
// import pastelBreeze from "../img/buchete/27pastel-breeze.webp";
// import lunarBliss from "../img/buchete/28lunar-bliss.webp";
// import soothe from "../img/buchete/29soothe.webp";
import blueveil from "../img/buchete/30blueveil.webp";
import pinkCloud from "../img/buchete/31pink-cloud.webp";
import nobility from "../img/buchete/32nobility.webp";
import orchidMist from "../img/buchete/33orchid-mist.webp";
// import fuchsiaEmbrace from "../img/buchete/34fuchsia-embrace.webp";
// import bloomscape from "../img/buchete/35bloomscape.webp";
// import majestic from "../img/buchete/36majestic.webp";
import marshmallowBloom from "../img/buchete/37marshmallow-bloom.webp";
import angelsTouch from "../img/buchete/38angels-touch.webp";
// import pinkMist from "../img/buchete/39pink-mist.webp";
// import delicacy from "../img/buchete/40delicacy.webp";
// import cottonCandy from "../img/buchete/41cotton-candy.webp";
import rosewaterCharm from "../img/buchete/42rosewater-charm.webp";
// import moonlightPetals from "../img/buchete/44moonlight-petals.webp";
import feather from "../img/buchete/45feather.webp";
// import buttercream from "../img/buchete/46buttercream.webp";
// import gemstone from "../img/buchete/47gemstone.webp";
// import roseDream from "../img/buchete/49rose-dream.webp";
import aura from "../img/buchete/50aura.webp";
// import midnightGarden from "../img/buchete/51midnight-garden.webp";
import dreamscape from "../img/buchete/52dreamscape.webp";
import floralFantasy from "../img/buchete/53floral-fantasy.webp";
import adore from "../img/buchete/54adore.webp";
// import eden from "../img/buchete/55eden.webp";
// import moonveil from "../img/buchete/56moonveil.webp";
import dazzle from "../img/buchete/57dazzle.webp";
// import velvetSpark from "../img/buchete/58velvet-spark.webp";
import blissful from "../img/buchete/59blissful.webp";
// import floralJolly from "../img/buchete/60floral-jolly.webp";
// import poise from "../img/buchete/61poise.webp";
import pinkDesire from "../img/buchete/62pink-desire.webp";
import pinkDelight from "../img/buchete/66pink-delight.webp";
import floralJoy from "../img/buchete/67floral-joy.webp";
// import peonyPearls from "../img/buchete/69peony-pearls.webp";
import celeste from "../img/buchete/70celeste.webp";
import luxeBlooms from "../img/buchete/71luxe-blooms.webp";
// import pastelHaze from "../img/buchete/72pastel-haze.webp";
// import satinique from "../img/buchete/74satinique.webp";
import pinkBlast from "../img/buchete/75pink-blast.webp";
// import playfulHydrangea from "../img/buchete/76playful-hydrangea.webp";
import gypsofilaCharm from "../img/buchete/78gypsofila-charm.webp";
// import gardenWhimsy from "../img/buchete/79garden-whimsy.webp";
// import gypsofilaShimmer from "../img/buchete/80gypsofila-shimmer.webp";
import noblespring from "../img/new/022noble.webp";
import mixeddreams from "../img/new/023mixeddreams.webp";
import secretmix from "../img/new/024secretmix.webp";
import ethernaldream from "../img/new/021eternaldream.webp";
import springwaltz from "../img/new/014springwaltz.webp";
import royalgarden from "../img/new/017royalgarden.webp";
import firstlight from "../img/new/019firstlight.webp";
// import poppy from "../img/new/007poppy.webp";
import springtimeromance from "../img/new/010springtimeromance.webp";
import ivy from "../img/new/005Ivy.webp";
import softrhapsody from "../img/new/011softrhapsody.webp";
// import classicsummer from "../img/new/029classic_summer.webp";
// import gardenparty from "../img/new/031garden_party.webp";
// import meadowwhisper from "../img/new/026meadow_whisper.webp";
// import junecharm from "../img/new/032june_charm.webp";

//51-199
const buchete = [
  // {
  //   id: 130,
  //   name: "June Charm",
  //   price: "900 lei",
  //   description: "Buchet format din hortensie, eustome, bujori si crizanteme.",
  //   images: [junecharm],
  // },
  // {
  //   id: 129,
  //   name: "Meadow Whisper",
  //   price: "1700 lei",
  //   description:
  //     "Buchet format din hortensii, molucella, eustome, matricaria, trandafiri, scobioza.",
  //   images: [meadowwhisper],
  // },
  // {
  //   id: 127,
  //   name: "Classic Summer",
  //   price: "850 lei",
  //   description:
  //     "Buchet format din gherbere, trandafiri, eustome, dianthus, matricaria. ",
  //   images: [classicsummer],
  // },
  // {
  //   id: 128,
  //   name: "Garden Party",
  //   price: "950 lei",
  //   description:
  //     "Buchet format din hortensie, trandafiri, eustome, crizanteme si eucalipt. ",
  //   images: [gardenparty],
  // },
  {
    id: 51,
    name: "Noble Spring",
    price: "950 lei",
    description:
      "Buchet format din hortensie, crizanteme, trandafiri Avalanche, eustome si eucalipt. ",
    images: [noblespring],
  },
  {
    id: 52,
    name: "Royal Garden",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip crenguta, trandafiri rosii si eucalipt.",
    images: [royalgarden],
  },
  {
    id: 53,
    name: "Mixed Dreams",
    price: "700 lei",
    description:
      "Buchet format din trandafiri de tip bujor, eustome, crizanteme, trandafiri de tip Avalanche și eucalipt.",
    images: [mixeddreams],
  },
  {
    id: 54,
    name: "Spring Waltz",
    price: "700 lei",
    description:
      "Buchet format din hortensie, gipsofila, trandafiri de tip bujor si eucalipt.",
    images: [springwaltz],
  },
  {
    id: 55,
    name: "Ethernal Dream",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor, oxypetalum si eucalipt.",
    images: [ethernaldream],
  },
  {
    id: 56,
    name: "Nobility",
    price: "950 lei",
    description: "Buchet elegant format dintr-un mix de trandafiri si eustome.",
    images: [nobility],
  },
  // {
  //   id: 57,
  //   name: "Fuchsia Embrace",
  //   price: "600 lei",
  //   description:
  //     "Buchet elegant format din crizanteme, trandafiri si eucalipt.",
  //   images: [fuchsiaEmbrace],
  // },
  {
    id: 58,
    name: "Secret Mix",
    price: "700 lei",
    description:
      "Buchet format din trandafiri de tip bujor, crizanteme, trandafiri Avalanche eucalipt și eustome.",
    images: [secretmix],
  },
  {
    id: 59,
    name: "Fleur",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, orhidei trandafiri, eucalipt,crizantema si gipsofila.",
    images: [fleur],
  },

  {
    id: 60,
    name: "Petal Embrace",
    price: "600 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor, crizanteme și gipsofila.",
    images: [petalEmbrace],
  },
  {
    id: 61,
    name: "First Light",
    price: "650 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip crenguta, dianthus si eucalipt.",
    images: [firstlight],
  },
  // {
  //   id: 62,
  //   name: "Poppy",
  //   price: "650 lei",
  //   description: "Buchet format din hortensie, trandafiri si eucalipt.",
  //   images: [poppy],
  // },
  {
    id: 64,
    name: "Roselight",
    price: "800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor, crizanteme si eustome.",
    images: [roselight],
  },
  {
    id: 65,
    name: "Springtime Romance",
    price: "1350 lei",
    description:
      "Buchet format din trandafiri de tip bujor, trandafiri Country si eucalipt.",
    images: [springtimeromance],
  },
  {
    id: 66,
    name: "Soft Rhapsody",
    price: "550 lei",
    description: "Buchet format din hortensie si gipsofila alba.",
    images: [softrhapsody],
  },
  {
    id: 67,
    name: "Ivy",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome si crizanteme.",
    images: [ivy],
  },
  // {
  //   id: 68,
  //   name: "Petal Affair",
  //   price: "1650 lei",
  //   description:
  //     "Buchet format din hortensie, bujori, trandafiri de tip bujori, crizanteme, eustome, matiole si gipsofila alba.",
  //   images: [petalAffair],
  //   // checkAvailability: true,
  // },

  // {
  //   id: 69,
  //   name: "Fresh Bloom",
  //   price: "1200 lei",
  //   description: "Buchet superb din hortensie, eustome si gipsofila.",
  //   images: [freshBloom],
  // },
  {
    id: 70,
    name: "Serene Bloom",
    price: "800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri. crizanteme, gipsofila si hypericum.",
    images: [sereneBloom],
  },
  {
    id: 71,
    name: "Pink Harmony",
    price: "1300 lei",
    description: "Buchet format din hortensie și trandafiri Silva Pink. ",
    images: [pinkHarmony],
  },

  {
    id: 72,
    name: "Floral Elegance",
    price: "1000 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor si eustome.",
    images: [floralElegance],
  },
  // {
  //   id: 73,
  //   name: "Noble",
  //   price: "1700 lei",
  //   description:
  //     "Buchet elegant format din hortensie, crizanteme, trandafiri, eustome. anthurium si eucalipt.",
  //   images: [noble],
  // },
  {
    id: 74,
    name: "Purity",
    price: "600 lei",
    description:
      "Buchet elegant format din trandafiri, crizanteme si gipsofila.",
    images: [purity],
  },
  // {
  //   id: 75,
  //   name: "Blush Rose",
  //   price: "950 lei",
  //   description:
  //     "Buchet elegant format din crizanteme, trandafiri de tip crenguta, eustome si eucalipt.",
  //   images: [blushRose],
  // },

  {
    id: 77,
    name: "Featherlight",
    price: "700 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor, crizanteme si gipsofila.",
    images: [featherlight],
  },

  {
    id: 78,
    name: "White Serenity",
    price: "1100 lei",
    description:
      "Buchet elegant format din hortensie, eustome, crizanteme, trandafiri si hipericum.",
    images: [whiteSerenity],
  },
  {
    id: 79,
    name: "Hydrangea Cascade",
    price: "550 lei",
    description: "Buchet rafinat format din hortensie si gipsofila.",
    images: [hydrangeaCascade],
  },
  // {
  //   id: 80,
  //   name: "Belle",
  //   price: "1250 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, dianthus, crizanteme si gipsofila.",
  //   images: [belle],
  // },
  {
    id: 82,
    name: "Petal Jewel",
    price: "1600 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, eustome, crizanteme, anthurium si eucalipt.",
    images: [petalJewel],
  },
  {
    id: 83,
    name: "Whispery",
    price: "700 lei",
    description: "Buchet elegant format din crizanteme, trandifiri si eustome.",
    images: [whispery],
  },
  {
    id: 84,
    name: "Snowdrop",
    price: "650 lei",
    description: "Buchet elegant format din crizanteme, trandafiri si eustome.",
    images: [snowdrop],
  },
  // {
  //   id: 87,
  //   name: "Soothe",
  //   price: "800 lei",
  //   description:
  //     "Buchet elegant format din trandafiri, crizanteme, gerbere si eustome.",
  //   images: [soothe],
  //   // checkAvailability: true,
  // },
  {
    id: 88,
    name: "Blueveil",
    price: "800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme si eucalipt.",
    images: [blueveil],
  },
  {
    id: 89,
    name: "Pink Cloud",
    price: "750 lei",
    description:
      "Buchet elegant format din trandafiri, dianthus, eustome si eucalipt.",
    images: [pinkCloud],
  },
  {
    id: 90,
    name: "Orchid Mist",
    price: "800 lei",
    description: "Buchet elegant format din hortensie, crizanteme si orhidee.",
    images: [orchidMist],
    // checkAvailability: true,
  },
  // {
  //   id: 91,
  //   name: "Bloomscape",
  //   price: "950 lei",
  //   description:
  //     "Buchet elegant format din hortensie, crizanteme, trandafiri si eucalipt.",
  //   images: [bloomscape],
  // },
  {
    id: 93,
    name: "Marshmallow Bloom",
    price: "900 lei",
    description: "Buchet elegant format din hortensie, crizanteme si eustome.",
    images: [marshmallowBloom],
  },
  {
    id: 94,
    name: "Angel's Touch",
    price: "700 lei",
    description: "Buchet elegant format din hortensie si gipsofila colorata.",
    images: [angelsTouch],
  },
  // {
  //   id: 95,
  //   name: "Pink Mist",
  //   price: "950 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, crizanteme, eustome, anthurium si eucalipt.",
  //   images: [pinkMist],
  // },
  {
    id: 98,
    name: "Rosewater Charm",
    price: "1000 lei",
    description:
      "Buchet elegant format din eustome, trandafiri de tip bujor, crizanteme si eucalipt.",
    images: [rosewaterCharm],
  },
  {
    id: 100,
    name: "Feather",
    price: "1000 lei",
    description:
      "Buchet elegant format din crizanteme. trandafiri, eustome si eucalipt.",
    images: [feather],
  },
  // {
  //   id: 101,
  //   name: "Buttercream",
  //   price: "800 lei",
  //   description:
  //     "Buchet elegant format din trandafiri, gerbere, astromerie, crizanteme si eustome.",
  //   images: [buttercream],
  // },
  {
    id: 103,
    name: "Aura",
    price: "1500 lei",
    description:
      "Buchet elegant format din hortensii, gipsofila colorata si eucalipt.",
    images: [aura],
  },
  // {
  //   id: 104,
  //   name: "Midnight Garden",
  //   price: "1400 lei",
  //   description:
  //     "Buchet elegant format din hortensie, crizanteme, eustome, hypericum, matiole si eucalipt.",
  //   images: [midnightGarden],
  //   // checkAvailability: true,
  // },
  {
    id: 105,
    name: "Dreamscape",
    price: "1700 lei",
    description:
      "Buchet elegant format din hortensie, crizanteme, mix de trandafiri, astromerii, matiole, gipsofila alba si eucalipt.",
    images: [dreamscape],
    // checkAvailability: true,
  },
  {
    id: 106,
    name: "Floral Fantasy",
    price: "1000 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme si eucalipt.",
    images: [floralFantasy],
  },
  {
    id: 107,
    name: "Adore",
    price: "1000 lei",
    description:
      "Buchet elegant format din hortensie, crizanteme, trandafiri si eustome.",
    images: [adore],
  },
  {
    id: 110,
    name: "Dazzle",
    price: "1200 lei",
    description:
      "Buchet elegant format din hortensie, dianthus, trandafiri, astromerie si gipsofila.",
    images: [dazzle],
  },
  {
    id: 112,
    name: "Blissful",
    price: "1300 lei",
    description:
      "Buchet elegant format din hortensie, dianthus, trandafiri, eustome si ozothamus.",
    images: [blissful],
  },
  // {
  //   id: 113,
  //   name: "Floral Jolly",
  //   price: "1200 lei",
  //   description:
  //     "Buchet elegant format din hortensie, eustome, trandafiri de tip bujor si gerbere.",
  //   images: [floralJolly],
  // },
  {
    id: 115,
    name: "Pink Desire",
    price: "1200 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor si eustome.",
    images: [pinkDesire],
  },

  {
    id: 116,
    name: "Pink Delight",
    price: "1400 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor, eustome si eucalipt.",
    images: [pinkDelight],
  },
  {
    id: 117,
    name: "Floral Joy",
    price: "1300 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme, gerbere, ozothamus si gipsofila.",
    images: [floralJoy],
  },
  // {
  //   id: 119,
  //   name: "Peony Pearls",
  //   price: "1100 lei",
  //   description: "Buchet elegant format din bujori albi.",
  //   images: [peonyPearls],
  // },
  {
    id: 120,
    name: "Celeste",
    price: "1400 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor si eucalipt.",
    images: [celeste],
  },
  {
    id: 121,
    name: "Luxe Blooms",
    price: "1600 lei",
    description:
      "Buchet elegant format din hortensie, dianthus, eustome, trandafiri de tip bujor si crizanteme.",
    images: [luxeBlooms],
  },

  {
    id: 122,
    name: "Pink Blast",
    price: "1500 lei",
    description:
      "Buchet elegant format din hortensie, eustome, trandafiri, si gipsofila.",
    images: [pinkBlast],
  },
  {
    id: 124,
    name: "Gypsophila Charm",
    price: "900 lei",
    description: "Buchet elegant format din gipsofila alba.",
    images: [gypsofilaCharm],
  },
];

export default buchete;
